export const WIRE = 0 as const;
export const SIGNAL = 1 as const;
export const STORE = 2 as const;
export const SUBTOKEN = 3 as const;
export const SIGNAL_GETTER = 4 as const;
